import { Key, RefreshCw, Loader2, ExternalLink } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

/**
 * Gradio URL Configuration Card
 */
export function GradioUrlCard({ gradioUrl, setGradioUrl, testingConnection, onTestConnection }) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg flex items-center gap-2">
          <Key className="w-5 h-5 text-amber-500" />
          iMagine Gradio URL
        </CardTitle>
        <CardDescription>
          Kopier URL fra iMagine &quot;Try&quot; deployment
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <div>
          <Input
            type="text"
            placeholder="https://ui-xxxxx.ifca-deployments.cloud.ai4eosc.eu"
            value={gradioUrl}
            onChange={(e) => setGradioUrl(e.target.value)}
            className="font-mono text-sm"
          />
        </div>
        <div className="flex items-center justify-between">
          <a 
            href="https://dashboard.cloud.imagine-ai.eu/catalog/modules/phyto-plankton-classification" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-teal-600 hover:underline inline-flex items-center gap-1"
          >
            Åpne iMagine Dashboard <ExternalLink className="w-3 h-3" />
          </a>
          <Button 
            variant="outline" 
            size="sm"
            onClick={onTestConnection}
            disabled={testingConnection || !gradioUrl.trim()}
          >
            {testingConnection ? (
              <Loader2 className="w-4 h-4 animate-spin mr-2" />
            ) : (
              <RefreshCw className="w-4 h-4 mr-2" />
            )}
            Test tilkobling
          </Button>
        </div>
        <div className="p-3 bg-amber-50 rounded-lg border border-amber-200">
          <p className="text-xs text-amber-800 font-medium mb-1">Slik får du URL:</p>
          <ol className="text-xs text-amber-700 list-decimal list-inside space-y-1">
            <li>Klikk lenken over for å åpne iMagine</li>
            <li>Søk etter &quot;phyto-plankton-classification&quot;</li>
            <li>Klikk &quot;Try&quot; knappen</li>
            <li>Kopier URL fra nettleseren (starter med https://ui-...)</li>
          </ol>
          <p className="text-xs text-amber-600 mt-2">⚠️ URL utløper etter 10 minutter</p>
        </div>
      </CardContent>
    </Card>
  );
}
